import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './auth/interceptor';
import { UserGuard } from './auth/interceptor/user.guard';
import { AdminGuard } from './auth/interceptor/admin.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { PaymentSuccessOpenpayComponent } from './pages/payment-success-openpay/payment-success-openpay.component';
import { BuyingTicketsComponent } from './pages/buying-tickets/buying-tickets.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'parkingArea',
        loadChildren: () =>
          import('./parking-area/parking-areas/parking-area.module').then(
            (m) => m.ParkingAreaModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'crear-zona-estacionamiento',
        loadChildren: () =>
          import(
            './parking-area/create-parking-area/create-parking-area.module'
          ).then((m) => m.CreateParkingAreaModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'parking-zone',
        loadChildren: () =>
          import('./parking-zone/parking-zone.module').then(
            (m) => m.ParkingZoneModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'event',
        loadChildren: () =>
          import('./events/components/events.module').then(
            (m) => m.EventsModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.module').then((m) => m.UsersModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'enclosures',
        loadChildren: () =>
          import('./enclosures/enclosures.module').then(
            (m) => m.EnclosuresModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'select-enclosure',
        loadChildren: () =>
          import('./select-enclosure/select-enclosure.module').then(
            (m) => m.SelectEnclosureModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'generate-qr',
        loadChildren: () =>
          import('./generate-qr/generate-qr.module').then(
            (m) => m.GenerateQRModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'create-qr',
        loadChildren: () =>
          import('./create-qr/create-qr.module').then((m) => m.CreateQRModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'eventType',
        loadChildren: () =>
          import('./event-type/event-type.module').then(
            (m) => m.EventTypeModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'createEventType',
        loadChildren: () =>
          import('./create-event-type/create-event-type.module').then(
            (m) => m.CreateEventTypeModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'type-prepaid',
        loadChildren: () =>
          import('./prepaid/prepaid.module').then((m) => m.PrepaidModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'historyQR',
        loadChildren: () =>
          import('./history-qrprepaid/history-qrprepaid.module').then(
            (m) => m.HistoryQRPrepaidModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'generateQrToUser',
        loadChildren: () =>
          import('./generate-qrto-user/generate-qrto-user.module').then(
            (m) => m.GenerateQRToUserModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'change-qr-type',
        loadChildren: () =>
          import('./change-qr-type/change-qr-type.module').then(
            (m) => m.ChangeQrTypeModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'prepaid-create',
        loadChildren: () =>
          import('./prepaid-create/prepaid-create.module').then(
            (m) => m.PrepaidCreateModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'locality',
        loadChildren: () =>
          import('./locality/locality.module').then((m) => m.LocalityModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'sales-user',
        loadChildren: () =>
          import('./sales-users/sales-users.module').then(
            (m) => m.SalesUsersModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'sales-user/:enclosure',
        loadChildren: () =>
          import('./sales-users/sales-users.module').then(
            (m) => m.SalesUsersModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: '/:enclosure',
        loadChildren: () =>
          import('./shared/shared.module').then((m) => m.SharedModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'user-tickets/:enclosureId',
        loadChildren: () =>
          import('./user-tickets/user-tickets.module').then(
            (m) => m.UserTicketsModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'user-tickets',
        loadChildren: () =>
          import('./user-tickets/user-tickets.module').then(
            (m) => m.UserTicketsModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'user-prepaid',
        loadChildren: () =>
          import('./user-prepaid/user-prepaid.module').then(
            (m) => m.UserPrepaidModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'user-recharge-prepaid',
        loadChildren: () =>
          import('./user-recharge-prepaid/user-recharge-prepaid.module').then(
            (m) => m.UserRechargePrepaidModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'user-prepaid-history',
        loadChildren: () =>
          import('./user-prepaid-history/user-prepaid-history.module').then(
            (m) => m.UserPrepaidHistoryModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'payment-summary/:id',
        loadChildren: () =>
          import('./payment-summary/payment-summary.module').then(
            (m) => m.PaymentSummaryModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'card-payment/:id',
        loadChildren: () =>
          import('./card-payment/card-payment.module').then(
            (m) => m.CardPaymentModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'user-pay-subscribe/:idAbonoUsuario/:costoTotal',
        loadChildren: () =>
          import('./user-pay-subscribe/user-pay-subscribe.module').then(
            (m) => m.UserPaySubscribeModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'payment-finish',
        loadChildren: () =>
          import('./payment-finish/payment-finish.module').then(
            (m) => m.PaymentFinishModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'payment-error',
        loadChildren: () =>
          import('./payment-error/payment-error.module').then(
            (m) => m.PaymentErrorModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'payment-pending',
        loadChildren: () =>
          import('./payment-pending/payment-pending.module').then(
            (m) => m.PaymentPendingModule
          ),
        canActivate: [UserGuard],
      },
      {
        path: 'general-report',
        loadChildren: () =>
          import('./general-report/general-report.module').then(
            (m) => m.GeneralReportModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'reports-zone-vip',
        loadChildren: () =>
          import('./reports-zone-vip/reports-zone-vip.module').then(
            (m) => m.ReportsZoneVIPModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'prepaid-reports',
        loadChildren: () =>
          import('./prepaid-reports/prepaid-reports.module').then(
            (m) => m.PrepaidReportsModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'prepaid-total-reports',
        loadChildren: () =>
          import('./prepaid-total-reports/prepaid-total-reports.module').then(
            (m) => m.PrepaidTotalReportsModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'prepaid-history-reports',
        loadChildren: () =>
          import(
            './prepaid-history-reports/prepaid-history-reports.module'
          ).then((m) => m.PrepaidHistoryReportsModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'change-pass',
        loadChildren: () =>
          import('./change-pass/change-pass.module').then(
            (m) => m.ChangePassModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'change-profile',
        loadChildren: () =>
          import('./change-profile/change-profile.module').then(
            (m) => m.ChangeProfileModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'scan-qr',
        loadChildren: () =>
          import('./scan-qr/scan-qr.module').then((m) => m.ScanQRModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'discount-code',
        loadChildren: () =>
          import('./discount-code/discount-code.module').then(
            (m) => m.DiscountCodeModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'create-discount-code',
        loadChildren: () =>
          import('./create-discount-code/create-discount-code.module').then(
            (m) => m.CreateDiscountCodeModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'reports-account',
        loadChildren: () =>
          import('./reports-account/reports-account.module').then(
            (m) => m.ReportsAccountModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'reports-infinity',
        loadChildren: () =>
          import('./report-infinity-qr/report-infinity-qr.module').then(
            (m) => m.ReportInfinityQRModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'report-by-month',
        loadChildren: () =>
          import('./report-by-month/report-by-month.module').then(
            (m) => m.ReportByMonthModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'qrabonados',
        loadChildren: () =>
          import('./qrabonados/qrabonados.module').then(
            (m) => m.QRAbonadosModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'report-by-closing-month',
        loadChildren: () =>
          import(
            './report-by-closing-month/report-by-closing-month.module'
          ).then((m) => m.ReportByClosingMonthModule),
        canActivate: [AdminGuard],
      },
      {
        path: 'scan-enclosure',
        loadChildren: () =>
          import('./scan-enclosure/scan-enclosure-routing.module').then(
            (m) => m.ScanEnclosureComponentModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'subscribers',
        loadChildren: () =>
          import('./subscribers/subscribers.module').then(
            (m) => m.SubcribersModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'subscribers-for-users/:id',
        loadChildren: () =>
          import('./subscribers-for-users/subscribers-for-users.module').then(
            (m) => m.SubcribersForUsersModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'scan-parking',
        loadChildren: () =>
          import('./scan-parking-qr/scan-parking.module').then(
            (m) => m.ScanParkingModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: '',
        loadChildren: () =>
          import('./config-parking-pen/config-parking-pen.module').then(
            (m) => m.ConfigParkingPenModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'enclosure-by-locality/:id',
        loadChildren: () =>
          import('./enclosure-by-locality/enclosure-by-locality.module').then(
            (m) => m.EnclosureByLocalityModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'create-locality',
        loadChildren: () =>
          import('./create-locality/create-locality.module').then(
            (m) => m.CreateLocalityModule
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'buying-tickets',
        component: BuyingTicketsComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'vehicles',
        loadChildren: () =>
          import('./vehicles/vehicles.module').then((m) => m.VehiclesModule),
        canActivate: [UserGuard],
      },
      {
        path: 'disclaimers',
        loadChildren: () =>
          import('./disclaimers/disclaimers.module').then(
            (m) => m.DisclaimersModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'socios-parkit',
        loadChildren: () =>
          import('./socios-parkit/socios-parkit.module').then(
            (m) => m.SociosParkitModule
          ),
        canActivate: [AdminGuard],
      },
    ],
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./shared/shared.module').then((m) => m.SharedModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'payment/success',
    component: PaymentSuccessOpenpayComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
